<!-- 充能条 -->
<template>
  <div class="charge-strip" @click="showChargeDialog" v-if="roomInfo.recharge_bar_info">
    <div class="christmas-trees-icon" :style="{'background-image': `url(${recharge_bar_info.icon})`}"></div>
    <div class="charge-strip-content">
      <div class="charge-strip-txt">
        <div class="charge-strip-exp">
          <template v-if="chargeBarReached>=100">
            <span class="charge-strip-exp-complete">Complete!</span>
          </template>
          <template v-else>
            <span class="charge-strip-exp-reached">{{recharge_bar_info.current_point}}</span>
            /
            <span class="charge-strip-exp-total">{{recharge_bar_info.max_point}}</span>
          </template>
        </div>
        <div class="charge-strip-lv">{{recharge_bar_info.level}}</div>
      </div>
      <div class="charge-strip-bar">
        <div class="charge-strip-bar-reached" :style="{width:chargeBarReached + '%'}"></div>
      </div>
    </div>
    <div class="charge-strip-tooltip" v-show="tooltipShow" @click="hideTooltip">
      <div class="charge-strip-tooltip-txt">{{tooltipContent}}</div>
    </div>
  </div>
  
  <iframe-view 
      :url="recharge_bar_info?.target_url"
      :width="375" 
      :height="460" 
      :draggable="true" 
      :extensible="false"
      v-model:show="iframeViewShow"
    ></iframe-view>
</template>


<script lang="ts" setup >
import { toRefs, onMounted, ref, computed, watch } from 'vue';
import { IRoomInfoResponseData } from '@/service/room/types';
import emitter,  { EB_EVENT_NAME }  from '@/utils/eventbus';
import iframeView from '@/components/iframe-view.vue';

const props = defineProps<{
  roomInfo: IRoomInfoResponseData;
  roomId: number;
}>();

const { roomInfo } = toRefs(props);
const recharge_bar_info = ref(roomInfo.value.recharge_bar_info);

const iframeViewShow = ref(false);
const showChargeDialog = () => {
  iframeViewShow.value = true;
};

const tooltipShow = ref(false);
const tooltipContent = ref('');
const hideTooltip = () => {
  tooltipShow.value = false;
};

const chargeBarReached = computed(() => {
  const {current_point, max_point, min_point} = recharge_bar_info.value;
  if(!current_point){
    return 0;
  }
  return Math.min(((current_point-min_point) / (max_point-min_point)), 1) * 100; 
});

watch(recharge_bar_info, (newValue) => {
  if(newValue?.notice?.content){
    setTimeout(() => {
      tooltipContent.value = newValue.notice.content;
      tooltipShow.value = true;
      setTimeout(() => {
        tooltipShow.value = false;
        tooltipContent.value = '';
      }, 1000 * newValue.notice.duration
      );
    }, 1000 * newValue.notice.delay
    );
  }
  
}, {immediate: true});

onMounted( () => {
  emitter.on(EB_EVENT_NAME.RECHARGE_BAR_INFO, (rechargeBarInfo => {
    console.log('EB_EVENT_NAME.RECHARGE_BAR_INFO:',rechargeBarInfo);
    recharge_bar_info.value = rechargeBarInfo;
  }));
});

</script>


<style lang="less" scoped>
.charge-strip {
  position: relative;
  width: 170px;
  height: 30px;
  background-image: linear-gradient(180deg, #5a5a5a 0%, #1f1f1f 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 0 6px 1px;
  cursor: pointer;

  .christmas-trees-icon {
    width: 23px;
    height: 25px;
    background: url("@/assets/christmas-trees.png") no-repeat center center;
    background-size: 100%;
    margin-right: 6px;
  }

  .charge-strip-content {
    .charge-strip-txt {
      height: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .charge-strip-exp {
        font-size: 12px;
        color: #fff;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 400;

        .charge-strip-exp-reached {
          color: #fde587;
        }

        .charge-strip-exp-complete {
          color: #fde587;
        }
      }

      .charge-strip-lv {
        font-size: 12px;
        color: #fde587;
        letter-spacing: 0;
        line-height: 12px;
        font-weight: 700;
      }
    }

    .charge-strip-bar {
      margin-top: 4px;
      height: 3px;
      width: 126px;
      background: rgba(153, 153, 153, 0.6);
      border-radius: 8px;

      .charge-strip-bar-reached {
        width: 0;
        height: 100%;
        border-radius: 8px;
        background-image: linear-gradient(180deg, #feffbe 0%, #fcd75c 100%);
      }
    }
  }

  .charge-strip-tooltip {
    position: absolute;
    z-index: 2;
    bottom: -58px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 16px;
    height: 44px;
    background: #fff;
    box-shadow: 0 4px 10px 0 rgba(153, 153, 153, 0.2);
    border-radius: 8px;
    font-size: 16px;
    color: #333;
    line-height: 44px;
    font-weight: 400;
    text-align: center;
    border-top: 1px solid #eee;

    &::before {
      display: block;
      content: ' ';
      width: 17px;
      height: 17px;
      position: absolute;
      left: 50%;
      top: -10px;
      transform: translateX(-50%) rotateZ(45deg);
      background: #fff;
      border-top: 1px solid #eee;
      border-left: 1px solid #eee;
    }

    .charge-strip-tooltip-txt {
      width: 100%;
      word-break: keep-all;
      white-space: nowrap;
    }
  }
}
</style>
